import _ from 'lodash';

export default function displayConversation($rootScope, $window, XucChat, XucPhoneHintService, XucDndService, XucVideoEventManager) {
  return {
    restrict: 'E',
    templateUrl: 'assets/javascripts/xcchat/directives/displayConversation.html',
    scope: {
      remoteParty: '@'
    },
    link: (scope) => {
      scope.pendingMessages = new Map();
      scope.messages = [];
      scope.remotePhoneNumber;
      scope.remoteParty;
      scope.remoteUserId;

      let lastPhoneHintStatus = null;
      let lastVideoStatus = null;

      XucChat.getRemotePartyConversation(scope.remoteParty).then(response => {
        mergeMessages(response.messages);
        XucChat.conversationDisplayed(response.remoteParty);
        if (response.remotePhoneNumber) {
          scope.remotePhoneNumber = response.remotePhoneNumber;
          scope.remoteParty = response.remoteParty;
          scope.remoteUserId = response.remoteUserId;
        }
        _subscribeToStatusUpdates(response);
      });

      function mergeMessages (newMessages) {
        let mergedMessages = scope.messages.concat(
          newMessages.filter(m1 => !scope.messages.find(m2 =>
            m1.date === m2.date
            && m1.content === m2.content
          )));
        mergedMessages.forEach(message => { if (message.distributed == undefined) message.distributed = true;});
        scope.messages = _.sortBy(mergedMessages, (message) => { return new Date(message.date); });
        _.defer(() => { scope.$apply(); });
      }

      scope.$on(XucChat.CHAT_RECEIVED_MESSAGE, (evt, message, remoteParty) => {
        if (scope.remoteParty == remoteParty) {
          mergeMessages([message]);
        }
      });

      scope.$on(XucChat.CHAT_SEND_PENDING_MESSAGE, (evt, message, remoteParty) => {
        if (scope.remoteParty == remoteParty) {
          scope.pendingMessages.set(message.id, message);
        }
      });

      scope.$on(XucChat.CHAT_SEND_MESSAGE_ACK, (evt, message, remoteParty) => {
        _changePendingToMessage(message, remoteParty);
      });

      scope.$on(XucChat.CHAT_SEND_MESSAGE_ACK_OFFLINE, (evt, message, remoteParty) => {
        if (!XucChat.isChatServerEnabled()) {
          XucChat.triggerToast('ChatNotRecv', 'alert-danger');
          message.distributed = false;
        } else XucChat.triggerToast('ChatOffline', 'alert-warning');
        _changePendingToMessage(message, remoteParty);
      });

      scope.$on(XucChat.CHAT_SEND_MESSAGE_NACK, (evt, message) => {
        if (scope.pendingMessages.has(message.sequence)) {
          XucChat.triggerToast('ChatError', 'alert-danger');
          scope.pendingMessages.delete(message.sequence);
        }
      });

      function _changePendingToMessage (message, remoteParty) {
        if (scope.remoteParty == remoteParty) {
          mergeMessages([message]);
          scope.pendingMessages.delete(message.id);
        }
      }

      function _broadcastLineStatus() {
        const statuses = [lastPhoneHintStatus, lastVideoStatus].filter(s => s !== null);
        if (statuses.length > 0) {
          $rootScope.$broadcast(XucChat.CURRENT_CHAT_LINESTATUS, Math.max(...statuses));
        }
      }

      function _onPhoneHint (hint) {
        if (scope.remotePhoneNumber && hint.number == scope.remotePhoneNumber) {
          lastPhoneHintStatus = hint.status;
          _broadcastLineStatus();
        }
      }

      function _onVideoEvent (videoStatus) {
        if (scope.remoteParty == videoStatus.fromUser) {
          const statusCode = _mapVideoStatusToCode(videoStatus.status);
          lastVideoStatus = statusCode;
          _broadcastLineStatus();
        }
      }

      function _mapVideoStatusToCode(status) {
        const statusMap = {
          'Available': 0,
          'Busy': 1
        };
        return statusMap[status] !== undefined ? statusMap[status] : 0;
      }

      function _onDndEvent(dndStatus) {
        if (scope.remoteUserId == dndStatus.userId) {
          $rootScope.$broadcast(XucChat.CURRENT_CHAT_DNDSTATUS, dndStatus.status);
        }
      }

      function _subscribeToStatusUpdates(response) {
        const { remotePhoneNumber, remoteParty, remoteUserId } = response;

        if (remotePhoneNumber) Cti.subscribeToPhoneHints([remotePhoneNumber]);
        if (remoteParty) Cti.subscribeToVideoStatus([remoteParty]);
        if (remoteUserId) Cti.subscribeToDndStatus([remoteUserId]);
      }

      scope.$on('$destroy', () => {
        XucChat.conversationEnded(scope.remoteParty);
      });

      XucPhoneHintService.addEventListener($rootScope, _onPhoneHint);
      XucVideoEventManager.subscribeToVideoStatusEvent($rootScope, _onVideoEvent);
      XucDndService.subscribeToDndEvent($rootScope, _onDndEvent);
    }
  };
}
